import { ResponsiveValue } from 'styled-system';
import { CoreTheme } from '../core';

export function getValueAt<T>(
  responsiveValue: ResponsiveValue<T, CoreTheme>,
  currentBreakpoint: number
): T {
  if (Array.isArray(responsiveValue)) {
    let validIndex = currentBreakpoint;
    if (currentBreakpoint > responsiveValue.length - 1) {
      validIndex = responsiveValue.length - 1;
    }
    while (!responsiveValue[validIndex] && validIndex > 0) {
      validIndex--;
    }
    return responsiveValue[validIndex] as T;
  } else {
    return responsiveValue as T;
  }
}
